import React, { useContext, useState } from 'react';
import {
	BottomSection,
	Breadcrumbs,
	Content,
	DeleteDataWrapper,
	Description,
	Section,
	Sidebar,
	Title,
	Wrapper,
} from './UploadData.styles';
import { ApButtonDanger } from '@alixpartners/ui-components';
import SkuUpload from './SkuUpload';
import { UploadSkuStateContext } from 'contexts/UploadSkuStateContext';
import { SkuFileArchiveContext } from 'contexts/SkuFileArchiveContext';
import DeleteDataModal from 'CategoryManagement/Components/DeleteDataModal';
import { deleteSkuData } from 'utils/apiRequests';
import { PERMISSIONS, PermissionsContext } from 'contexts/PermissionsContext';

const UploadData = ({ setCurrentContent }) => {
	const { permissions } = useContext(PermissionsContext);
	const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);

	const canDeleteAllData = permissions.includes(
		PERMISSIONS.TransactionsDeleteAll
	);
	const { skuStatus: status } = useContext(UploadSkuStateContext);
	const { fileArchive, refetch } = useContext(SkuFileArchiveContext);

	const handleDeleteAllData = () => {
		setIsDeleting(true);

		deleteSkuData()
			.then(response => {
				if (response.statusCode === 200) {
					setIsDeleting(false);
					setDeleteModalOpen(false);
					refetch();
				}
			})
			.catch(() => {
				setIsDeleting(false);
			});
	};

	return (
		<Wrapper>
			<Sidebar>
				<Breadcrumbs>
					<span onClick={() => setCurrentContent(0)}>SKU Analysis</span>&nbsp;/&nbsp;<span
					>
						Upload Data
					</span>
				</Breadcrumbs>
				<Section>
					<div>
						<Title>Data upload</Title>
						<Description>
							<p>Data upload process:</p>
							<p>1. Upload file into the system</p>
						</Description>
					</div>
					<div>
						<BottomSection>
							<Title>Delete data</Title>
							<Description>
								Data deletion clears all the SKU Analysis data from the
								application.
							</Description>
							<DeleteDataWrapper>
								<ApButtonDanger
									title={'Delete'}
									iconName="delete"
									onClick={e => {
										e.preventDefault();
										setDeleteModalOpen(true);
									}}
									// disabled={!isLastUploadCompleted}
								>
									Delete all data
								</ApButtonDanger>
							</DeleteDataWrapper>
						</BottomSection>
					</div>
				</Section>
			</Sidebar>
			<Content>
				<SkuUpload
					status={status}
					fileArchive={fileArchive}
					fetchFileArchive={refetch}
				/>
			</Content>
			{canDeleteAllData &&
				isDeleteModalOpen && (
					<DeleteDataModal
						onConfirm={handleDeleteAllData}
						onCancel={() => (!isDeleting ? setDeleteModalOpen(false) : null)}
						inProgress={isDeleting}
					/>
				)}
		</Wrapper>
	);
};

export default UploadData;
